/*
 * Copyright 2026 Sony Corporation
 */
import { createTheme } from '@mui/material';

export const theme = createTheme({
  palette: { mode: 'dark', primary: { main: '#3794ff' }, background: { default: '#1e1e1e', paper: '#252526' } },
  components: {
    MuiPaper: { styleOverrides: { root: { backgroundImage: 'none' } } },
    MuiCssBaseline: {
      // Without a dark colour scheme the browser draws its light scrollbars on the dark panels.
      styleOverrides: {
        html: { colorScheme: 'dark' },
        '*': { scrollbarWidth: 'thin', scrollbarColor: '#5a5a5a transparent' },
      },
    },
  },
});
